var _circle, _path, _path2, _g, _ellipse, _ellipse2, _ellipse3, _g2, _rect, _ellipse4, _path3, _path4, _circle2, _circle3, _circle4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotLoggedIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 64,
    r: 64,
    fill: "#F2F4F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.32 37.9671C54.32 30.1738 60.6378 23.856 68.4311 23.856C76.2244 23.856 82.5421 30.1738 82.5421 37.9671V68.4813H54.32V37.9671Z",
    stroke: "white",
    strokeWidth: 9.80347
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_12353_70757",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 49,
    y: 20,
    width: 39,
    height: 55
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.32 39.4581C54.32 31.6648 60.6378 25.3471 68.4311 25.3471C76.2244 25.3471 82.5421 31.6648 82.5421 39.4581V69.9724H54.32V39.4581Z",
    stroke: "white",
    strokeWidth: 9.80347
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_12353_70757)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 46.436,
    y: 46.5412,
    width: 43.9904,
    height: 8.2016,
    fill: "#D6E4FF"
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 90.0534,
    cy: 53.2517,
    rx: 1.1184,
    ry: 1.4912,
    fill: "#B0CAFF"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 86.3255,
    cy: 53.2517,
    rx: 1.1184,
    ry: 1.4912,
    fill: "#B0CAFF"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 94.5271,
    cy: 53.2517,
    rx: 1.1184,
    ry: 1.4912,
    fill: "#B0CAFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12353_70757)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 36.743,
    y: 49.5237,
    width: 61.1392,
    height: 46.9728,
    rx: 4.45612,
    fill: "white"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 39.7255,
    y: 56.9798,
    width: 55.1744,
    height: 36.5344,
    rx: 1.78245,
    fill: "#B0CAFF"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 79.6151,
    cy: 69.655,
    rx: 7.0832,
    ry: 6.7104,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76.4761 74.1222C76.55 73.695 76.9207 73.3829 77.3542 73.3829H81.8759C82.3095 73.3829 82.6802 73.695 82.7541 74.1222L85.0265 87.2517C85.1208 87.7966 84.7013 88.2949 84.1484 88.2949H75.0818C74.5288 88.2949 74.1093 87.7966 74.2036 87.2517L76.4761 74.1222Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5206 77.111C43.0884 77.111 42.7219 77.4225 42.6206 77.8427C41.3212 83.2297 36.4699 87.2319 30.6838 87.2319C23.9026 87.2319 18.4053 81.7346 18.4053 74.9533C18.4053 68.172 23.9026 62.6747 30.6838 62.6747C35.6426 62.6747 39.9147 65.6141 41.8529 69.8456C42.0048 70.1771 42.3299 70.4006 42.6944 70.4006H62.8391H65.076H67.9127C68.4049 70.4006 68.8039 70.7996 68.8039 71.2918V82.1846C68.8039 82.6768 68.4049 83.0758 67.9127 83.0758H63.7303C63.2381 83.0758 62.8391 82.6768 62.8391 82.1846V78.0022C62.8391 77.51 62.4401 77.111 61.9479 77.111H60.0025C59.5103 77.111 59.1113 77.51 59.1113 78.0022V80.6933C59.1113 81.1855 58.7123 81.5845 58.2201 81.5845H54.0377C53.5455 81.5845 53.1465 81.1855 53.1465 80.6933V78.0022C53.1465 77.51 52.7475 77.111 52.2553 77.111H43.5206ZM30.6839 74.9534C30.6839 77.2138 28.8514 79.0462 26.591 79.0462C24.3306 79.0462 22.4981 77.2138 22.4981 74.9534C22.4981 72.6929 24.3306 70.8605 26.591 70.8605C28.8514 70.8605 30.6839 72.6929 30.6839 74.9534Z",
    fill: "#0041C2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 88.9351,
    cy: 53.2517,
    r: 1.4912,
    fill: "#D6E4FF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 84.4615,
    cy: 53.2517,
    r: 1.4912,
    fill: "#D6E4FF"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.4087,
    cy: 53.2517,
    r: 1.4912,
    fill: "#D6E4FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12353_70757",
    x: 36.743,
    y: 49.5237,
    width: 63.8129,
    height: 49.6465,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2.67367,
    dy: 2.67367
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.690196 0 0 0 0 0.792157 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12353_70757"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12353_70757",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotLoggedIn);
export default __webpack_public_path__ + "static/media/not-logged-in.d8ebcde97705600b2279d77e6358d663.svg";
export { ForwardRef as ReactComponent };